import { render, staticRenderFns } from "./posProductCard.vue?vue&type=template&id=650a743d&scoped=true"
import script from "./posProductCard.vue?vue&type=script&lang=js"
export * from "./posProductCard.vue?vue&type=script&lang=js"
import style0 from "./posProductCard.vue?vue&type=style&index=0&id=650a743d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650a743d",
  null
  
)

export default component.exports